import { render, staticRenderFns } from "./JoinChat.vue?vue&type=template&id=993af24c&scoped=true&"
import script from "./JoinChat.vue?vue&type=script&lang=js&"
export * from "./JoinChat.vue?vue&type=script&lang=js&"
import style0 from "./JoinChat.vue?vue&type=style&index=0&id=993af24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993af24c",
  null
  
)

export default component.exports